// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%; /* Default for small screens */
    margin: 0 auto; /* Center align */

  }

  @media (min-width: 768px) {
    /* Medium screens (tablets and above) */
    .chat-container {
        width: 75%; /* 75% width for medium screens */
    }
}

@media (min-width: 992px) {
    /* Large screens (desktops and above) */
    .chat-container {
        width: 75%; /* 75% width for large screens */
    }
}
  .chat-header{
    background-color: #FDF5F2;
    border-radius: 10px;
    padding:30px 30px;
  }
  
  .chat-content {
    overflow-y: auto;
    max-height: 50vh;
    padding-bottom: 20px;
  
}
.wrapperchat{
  border-left: 1px solid #E5E5E5;  /* Left border */
  border-right: 1px solid #E5E5E5; /* Right border */
  border-bottom: 1px solid #E5E5E5; /* Bottom border */
  border-radius: 0 0 10px 10px; /* Optional: Rounded corners at the bottom */

}
  .message-box {
    max-width: 60%;
    padding: 10px 15px;
    border-radius: 20px;
    margin-bottom: 25px;
    position: relative;
    color: white;
    height: max-content;
  }
  
  .support-message {
    background-color: #e6e3e3ab;
    color:black;
    border-bottom-left-radius: 0px;
  }
  
  .patient-message {
    background-color: #ff6036;
    color:white;
    border-bottom-right-radius: 0px;
  }
  
  .message-text {
    font-size: 0.85rem;
  }
  
  .message-time {
    font-size: 0.6rem;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.7);
    position: absolute;
    bottom: -18px;
    right: 10px;
  }
  

  
  .chat-input-box {
    border-radius: 25px;
    background-color: #E5E5E5;
    flex: 1 1;
    margin-right: 10px;
    margin-left: 10px;
    padding:8px !important;
    height:3rem
  }
  
  .chat-send-button {
    background-color: #ff6036;
    color: white;
    border: none;
    border-radius: 25px;
    font-size: 0.9rem;
    padding: 10px;
    width:6rem;
    height:3rem
  }
  
  @media (max-width: 768px) {
    .message-box {
      max-width: 80%;
      font-size: 0.9rem;
    }
  
    .message-text {
      font-size: 0.9rem;
    }
  
    .message-time {
      font-size: 0.7rem;
    }
  
    .chat-input-box {
      margin-right: 5px;
    }
  }


  .toggle-el {
    height: 180px;
    min-height: 150px;
    transition: all 0.2s ease;
    opacity: 1;
    margin-top: 1rem;
  }
  input[type="checkbox"].hide-input:checked + .toggle-el {
   min-height: 0;
    height: 0;
    opacity: 0;
    padding-top: 0;
    padding-bottom: 0;
  }
  input.hide-input {
    position: absolute;
    left: -999em;
  }
  label.toggle {
    text-align: center;
    display: inline-block;
    cursor: pointer;
    font-size: 1rem;
    color: hsl(0, 0%, 14%);
    border-radius: 3px;
    -webkit-user-select: none;
            user-select: none;
  }
  
  
  `, "",{"version":3,"sources":["webpack://./src/assets/css/ticket.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW,EAAE,8BAA8B;IAC3C,cAAc,EAAE,iBAAiB;;EAEnC;;EAEA;IACE,uCAAuC;IACvC;QACI,UAAU,EAAE,iCAAiC;IACjD;AACJ;;AAEA;IACI,uCAAuC;IACvC;QACI,UAAU,EAAE,gCAAgC;IAChD;AACJ;EACE;IACE,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;;AAExB;AACA;EACE,8BAA8B,GAAG,gBAAgB;EACjD,+BAA+B,EAAE,iBAAiB;EAClD,gCAAgC,EAAE,kBAAkB;EACpD,4BAA4B,EAAE,4CAA4C;;AAE5E;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,WAAW;EACb;;;;EAIA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,SAAO;IACP,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB;EACF;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,UAAU;IACV;EACF;;EAEA;IACE;MACE,cAAc;MACd,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;EACF;;;EAGA;IACE,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,UAAU;IACV,gBAAgB;EAClB;EACA;GACC,aAAa;IACZ,SAAS;IACT,UAAU;IACV,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;EACnB","sourcesContent":[".chat-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%; /* Default for small screens */\n    margin: 0 auto; /* Center align */\n\n  }\n\n  @media (min-width: 768px) {\n    /* Medium screens (tablets and above) */\n    .chat-container {\n        width: 75%; /* 75% width for medium screens */\n    }\n}\n\n@media (min-width: 992px) {\n    /* Large screens (desktops and above) */\n    .chat-container {\n        width: 75%; /* 75% width for large screens */\n    }\n}\n  .chat-header{\n    background-color: #FDF5F2;\n    border-radius: 10px;\n    padding:30px 30px;\n  }\n  \n  .chat-content {\n    overflow-y: auto;\n    max-height: 50vh;\n    padding-bottom: 20px;\n  \n}\n.wrapperchat{\n  border-left: 1px solid #E5E5E5;  /* Left border */\n  border-right: 1px solid #E5E5E5; /* Right border */\n  border-bottom: 1px solid #E5E5E5; /* Bottom border */\n  border-radius: 0 0 10px 10px; /* Optional: Rounded corners at the bottom */\n\n}\n  .message-box {\n    max-width: 60%;\n    padding: 10px 15px;\n    border-radius: 20px;\n    margin-bottom: 25px;\n    position: relative;\n    color: white;\n    height: max-content;\n  }\n  \n  .support-message {\n    background-color: #e6e3e3ab;\n    color:black;\n    border-bottom-left-radius: 0px;\n  }\n  \n  .patient-message {\n    background-color: #ff6036;\n    color:white;\n    border-bottom-right-radius: 0px;\n  }\n  \n  .message-text {\n    font-size: 0.85rem;\n  }\n  \n  .message-time {\n    font-size: 0.6rem;\n    white-space: nowrap;\n    color: rgba(0, 0, 0, 0.7);\n    position: absolute;\n    bottom: -18px;\n    right: 10px;\n  }\n  \n\n  \n  .chat-input-box {\n    border-radius: 25px;\n    background-color: #E5E5E5;\n    flex: 1;\n    margin-right: 10px;\n    margin-left: 10px;\n    padding:8px !important;\n    height:3rem\n  }\n  \n  .chat-send-button {\n    background-color: #ff6036;\n    color: white;\n    border: none;\n    border-radius: 25px;\n    font-size: 0.9rem;\n    padding: 10px;\n    width:6rem;\n    height:3rem\n  }\n  \n  @media (max-width: 768px) {\n    .message-box {\n      max-width: 80%;\n      font-size: 0.9rem;\n    }\n  \n    .message-text {\n      font-size: 0.9rem;\n    }\n  \n    .message-time {\n      font-size: 0.7rem;\n    }\n  \n    .chat-input-box {\n      margin-right: 5px;\n    }\n  }\n\n\n  .toggle-el {\n    height: 180px;\n    min-height: 150px;\n    transition: all 0.2s ease;\n    opacity: 1;\n    margin-top: 1rem;\n  }\n  input[type=\"checkbox\"].hide-input:checked + .toggle-el {\n   min-height: 0;\n    height: 0;\n    opacity: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  input.hide-input {\n    position: absolute;\n    left: -999em;\n  }\n  label.toggle {\n    text-align: center;\n    display: inline-block;\n    cursor: pointer;\n    font-size: 1rem;\n    color: hsl(0, 0%, 14%);\n    border-radius: 3px;\n    user-select: none;\n  }\n  \n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
